import { useState } from 'react';
import './Login.css'; // Import the CSS file

const SECRET_PASSWORD = process.env.REACT_APP_INTERNAL_DEV_PASSWORD;
const PASSWORD_HASH = btoa(SECRET_PASSWORD);

const Login = ({ setIsAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (btoa(password) === PASSWORD_HASH) {
      localStorage.setItem('auth', PASSWORD_HASH);
      setIsAuthenticated(true);
    } else {
      setError('Incorrect password');
    }
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSubmit(); // Trigger login when Enter is pressed
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Ema - Internal DEV</h2>
        <input
          className="login-input"
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKeyDown} // Listening for Enter key
        />
        <button
          className="login-button"
          onClick={handleSubmit}
          disabled={password.trim() === ''}
        >
          Login
        </button>
        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
